- section: Skills
  note: >-
    Enchanted Daggers/Form of the Assassin lifesteal damage may not be shown in arcdps area stats or
    parsed arcdps logs.


    Enter your total Cosmic Wisdom uptime in two input boxes, regardless of active legend; Bolstered
    Bonds gives attributes based on *equipped* legends.
  items:

    - id: battle-scars
      text: Battle Scars
      subText: Battle Scars
      amountData:
        label: 'proc/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Siphon Base Coefficient: 117
          Siphon Coefficient: 0.006
      wvwModifiers:
        attributes:
          Siphon Base Coefficient: 58
          Siphon Coefficient: 0.003
      temporaryBuff: true

    - id: facet-of-nature-assassin
      text: Facet of Nature—Assassin
      subText: Facet of Nature—Assassin
      amountData:
        label: 'proc/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Siphon Base Coefficient: 53
          Siphon Coefficient: 0.0666
      temporaryBuff: true

    - id: facet-of-darkness-draconic-echo
      text: Facet of Darkness
      subText: draconic echo passive
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Critical Chance: 10%
      wvwModifiers:
        attributes:
          Critical Chance: 5%
      gw2id: 28379
      defaultEnabled: false
      temporaryBuff: true

    - id: facet-of-elements-draconic-echo
      text: Facet of Elements
      subText: draconic echo passive
      amountData:
        label: '% uptime'
        default: 20
        quantityEntered: 100
      modifiers:
        conversion:
          Condition Damage: {Condition Damage: 10%} # increases condition damage attribute rather than outgoing condition damage
      wvwModifiers:
        conversion:
          Condition Damage: {Condition Damage: 5%} # increases condition damage attribute rather than outgoing condition damage
      gw2id: 27014
      temporaryBuff: true

    - id: facet-of-strength-draconic-echo
      text: Facet of Strength
      subText: draconic echo passive
      amountData:
        label: '% uptime'
        default: 20
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [5%, add]
      gw2id: 26644

    - id: facet-of-chaos-draconic-echo
      text: Facet of Chaos (Draconic Echo)
      subText: draconic echo passive, 100% uptime
      modifiers:
        damage:
          Damage Reduction: [10%, unknown]
      wvwModifiers:
        damage:
          Damage Reduction: [5%, unknown]
      gw2id: 27760
      defaultEnabled: false

    - id: facet-of-nature-draconic-echo
      text: Facet of Nature (Draconic Echo)
      subText: draconic echo passive, 100% uptime
      modifiers:
        attributes:
          Boon Duration: 10%
      wvwModifiers:
        attributes:
          Boon Duration: 5%
      gw2id: 29371
      defaultEnabled: false
      temporaryBuff: true

    - id: burst-of-strength
      text: Burst of Strength
      subText: damage buff only
      amountData:
        label: '% uptime'
        default: 39
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add]
          Outgoing Condition Damage: [5%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, add]
          Outgoing Condition Damage: [7%, add]
      gw2id: 28113

    - id: soulcleaves-summit
      text: Soulcleave's Summit
      subText: siphon only
      amountData:
        label: 'proc/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Siphon Base Coefficient: 325
          Siphon Coefficient: 0.1
      wvwModifiers:
        attributes:
          Siphon Base Coefficient: 325
          Siphon Coefficient: 0.04
      gw2id: 45773
      temporaryBuff: true

    - id: enchanted-daggers
      text: Enchanted Daggers
      subText: or Form of the Assassin
      amountData:
        label: 'dagger/s'
        default: 0
        defaultInput: ???
        quantityEntered: 1
      modifiers:
        attributes:
          Siphon Base Coefficient: 1028
          Siphon Coefficient: 0.06
      wvwModifiers:
        attributes:
          Siphon Base Coefficient: 858
          Siphon Coefficient: 0.05
      gw2id: 26937
      temporaryBuff: true

    - id: vengeful-hammers
      text: Vengeful Hammers
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [20%, mult]
      gw2id: 26557

    - id: forced-engagement
      text: Forced Engagement
      subText: damage reduction while active
      modifiers:
        damage:
          Damage Reduction: [33%, mult]
      gw2id: 26679

    - id: cosmic-wisdom-assassin
      text: Cosmic Wisdom
      subText: with Assassin equipped
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: cosmic-wisdom
            group: true
      modifiers:
        attributes:
          Power: [75, buff]
          Ferocity: [75, buff]
      wvwModifiers:
        attributes:
          Power: [75, buff]
          Ferocity: [75, buff]
      gw2id: 77371
      temporaryBuff: true

    - id: cosmic-wisdom-centaur
      text: Cosmic Wisdom
      subText: with Centaur equipped
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: cosmic-wisdom
            group: true
      modifiers:
        attributes:
          Healing Power: [150, buff]
          Concentration: [150, buff]
      wvwModifiers:
        attributes:
          Healing Power: [75, buff]
          Concentration: [75, buff]
      gw2id: 77371
      temporaryBuff: true

    - id: cosmic-wisdom-demon
      text: Cosmic Wisdom
      subText: with Demon equipped
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: cosmic-wisdom
            group: true
      modifiers:
        attributes:
          Condition Damage: [75, buff]
          Expertise: [75, buff]
      wvwModifiers:
        attributes:
          Condition Damage: [75, buff]
          Expertise: [75, buff]
      gw2id: 77371
      temporaryBuff: true

    - id: cosmic-wisdom-dwarf
      text: Cosmic Wisdom
      subText: with Dwarf equipped
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: cosmic-wisdom
            group: true
      modifiers:
        attributes:
          Toughness: [150, buff]
          Vitality: [150, buff]
      wvwModifiers:
        attributes:
          Toughness: [75, buff]
          Vitality: [75, buff]
      gw2id: 77371
      temporaryBuff: true

    - id: cosmic-wisdom-entity
      text: Cosmic Wisdom
      subText: with Entity equipped
      amountData:
        label: '% uptime'
        default: 0
        defaultInput: ???
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation:
            category: cosmic-wisdom
            group: true
      modifiers:
        attributes:
          Power: [75, buff]
          Precision: [75, buff]
          Toughness: [75, buff]
          Vitality: [75, buff]
          Concentration: [75, buff]
          Condition Damage: [75, buff]
          Expertise: [75, buff]
          Ferocity: [75, buff]
          Healing Power: [75, buff]
      wvwModifiers:
        attributes:
          Power: [50, buff]
          Precision: [50, buff]
          Toughness: [50, buff]
          Vitality: [50, buff]
          Concentration: [50, buff]
          Condition Damage: [50, buff]
          Expertise: [50, buff]
          Ferocity: [50, buff]
          Healing Power: [50, buff]
      gw2id: 77371
      temporaryBuff: true

    - id: shielding-hands
      text: Shielding Hands
      subText: with Centaur, while active
      modifiers:
        damage:
          Damage Reduction: [75%, mult]
      gw2id: 77043

- section: Corruption
  id: 14
  items:

    - id: acolyte-of-torment
      text: Acolyte of Torment
      modifiers:
        damage:
          Outgoing Torment Damage: [10%, mult]
      gw2id: 1793
      defaultEnabled: true

    # - id: replenishing-despair
    #   text: Replenishing Despair
    #   amountData:
    #     label: 'proc/s'
    #     default: 0
    #     defaultInput: ???
    #     quantityEntered: 1
    #   modifiers:
    #     attributes:
    #       Siphon Base Coefficient:
    #       Siphon Coefficient:
    #   gw2id: 1741
    #   defaultEnabled: true
    #   temporaryBuff: true

    - id: seething-malice
      text: Seething Malice
      minor: true
      modifiers:
        attributes:
          Condition Damage: [120, buff]
      gw2id: 1801
      defaultEnabled: true
      temporaryBuff: false

    - id: demonic-resistance
      text: Demonic Resistance
      subText: 100% resistance
      modifiers:
        damage:
          Damage Reduction: [20%, mult]
      wvwModifiers:
        damage:
          Damage Reduction: [10%, mult]
      gw2id: 1726
      defaultEnabled: true

    - id: pact-of-pain
      text: Pact of Pain
      modifiers:
        attributes:
          Condition Duration: 15%
      wvwModifiers:
        attributes:
          Condition Duration: 7%
      gw2id: 1714
      defaultEnabled: true
      temporaryBuff: true

    - id: yearning-empowerment
      text: Yearning Empowerment
      minor: true
      modifiers:
        attributes:
          Condition Duration: 10%
      gw2id: 1744
      defaultEnabled: true
      temporaryBuff: true

- section: Retribution
  id: 9
  items:

    - id: close-quarters
      text: Close Quarters
      subText: ranged
      modifiers:
        damage:
          Damage Reduction: [10%, mult]
      gw2id: 1728
      defaultEnabled: false

    - id: dwarven-battle-training
      text: Dwarven Battle Training
      amountData:
        label: '% weakness'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 1740
      defaultEnabled: true

    - id: determined-resolution
      text: Determined Resolution
      subText: 100% resolution
      minor: true
      modifiers:
        damage:
          Damage Reduction: [10%, mult]
      gw2id: 1713
      defaultEnabled: true

    - id: vicious-reprisal
      text: Vicious Reprisal
      amountData:
        label: '% resolution'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing All Damage: [10%, add]
      gw2id: 1779
      defaultEnabled: true

    - id: versed-in-stone
      text: Versed in Stone
      modifiers:
        conversion:
          Power: {Toughness: 13%}
      wvwModifiers:
        conversion:
          Power: {Toughness: 4%}
      gw2id: 1770
      defaultEnabled: true
      temporaryBuff: false

- section: Invocation
  id: 3
  items:

    - id: rising-tide
      text: Rising Tide
      amountData:
        label: '% scholar'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [7%, mult]
      gw2id: 1761
      defaultEnabled: true

    - id: ferocious-aggression
      text: Ferocious Aggression
      minor: true
      amountData:
        label: '% fury'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing All Damage: [10%, add]
      wvwModifiers:
        damage:
          Outgoing All Damage: [7%, add]
      gw2id: 1758
      defaultEnabled: true

    - id: roiling-mists
      text: Roiling Mists
      subText: 100% fury
      modifiers:
        attributes:
          Critical Chance: 25%
      wvwModifiers:
        attributes:
          Critical Chance: 20%
      gw2id: 1719
      defaultEnabled: true
      temporaryBuff: true

- section: Devastation
  id: 15
  items:

    - id: unsuspecting-strikes
      text: Unsuspecting Strikes
      amountData:
        label: '% above 80'
        default: 20
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [20%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 1767
      defaultEnabled: true

    - id: destructive-impulses-base
      text: Destructive Impulses
      subText: base
      minor: true
      modifiers:
        damage:
          Outgoing All Damage: [5%, add]
      gw2id: 1724
      defaultEnabled: true

    - id: destructive-impulses-dual
      text: Destructive Impulses
      subText: bonus
      minor: true
      amountData:
        label: '% dual wielding'
        default: 50
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing All Damage: [2.5%, add]
      wvwModifiers:
        damage:
          Outgoing All Damage: [5%, add]
      gw2id: 1724
      defaultEnabled: true

    - id: notoriety
      text: Notoriety
      amountData:
        label: 'might'
        default: 25
        quantityEntered: 25
      modifiers:
        attributes:
          Power: [250, buff]
          Condition Damage: [-250, buff]
      gw2id: 1765
      defaultEnabled: true
      temporaryBuff: true

    - id: targeted-destruction
      text: Targeted Destruction
      amountData:
        label: 'vulnerability'
        default: 25
        quantityEntered: 25
      minor: true
      modifiers:
        damage:
          Outgoing Strike Damage: [12.5%, mult]
      gw2id: 1792
      defaultEnabled: true

    - id: swift-termination
      text: Swift Termination
      amountData:
        label: '% below 50'
        default: 50
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [20%, mult]
      gw2id: 1800
      defaultEnabled: true

- section: Salvation
  id: 12
  items:

    - id: life-attunement
      text: Life Attunement
      minor: true
      modifiers:
        attributes:
          Healing Power: [120, buff]
          Concentration: [8, buff] # pseudo-conversion of own healing power
        conversion:
          Concentration: {Healing Power: 7%}
      wvwModifiers:
        attributes:
          Healing Power: [120, buff]
          Concentration: [5, buff] # pseudo-conversion of own healing power
        conversion:
          Concentration: {Healing Power: 4%}
      gw2id: 1821
      defaultEnabled: true
      temporaryBuff: false

    - id: invoking-harmony
      text: Invoking Harmony
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        attributes:
          Outgoing Healing: 20%
      wvwModifiers:
        attributes:
          Outgoing Healing: 10%
      gw2id: 1823
      defaultEnabled: true
      temporaryBuff: true

    - id: serene-rejuvenation
      text: Serene Rejuvenation
      minor: true
      modifiers:
        attributes:
          Outgoing Healing: 20%
      wvwModifiers:
        attributes:
          Outgoing Healing: 15%
      gw2id: 1814
      defaultEnabled: true
      temporaryBuff: false

    - id: unyielding-devotion
      text: Unyielding Devotion
      subText: 100%
      modifiers:
        damage:
          Damage Reduction: [15%, mult]
      gw2id: 1825
      defaultEnabled: false

- section: Herald
  id: 52
  items:

    - id: draconic-fortitude
      text: Draconic Fortitude
      minor: true
      modifiers:
        attributes:
          Maximum Health: 10%
      gw2id: 1737
      defaultEnabled: true
      temporaryBuff: false

    - id: hardening-persistence
      text: Hardening Persistence
      amountData:
        label: 'upkeep'
        default: 10
        quantityEntered: 1
        disableBlacklist: true
      modifiers:
        damage:
          Damage Reduction: [1.5%, mult]
      gw2id: 1730
      defaultEnabled: false

    - id: elevated-compassion
      text: Elevated Compassion
      modifiers:
        conversion:
          Concentration: {Power: 13%}
      gw2id: 1746
      defaultEnabled: true
      temporaryBuff: false

    - id: reinforced-potency-base
      text: Reinforced Potency
      subText: base
      minor: true
      modifiers:
        attributes:
          Concentration: [240, converted]
      wvwModifiers:
        attributes:
          Concentration: [60, converted]
      gw2id: 1788
      defaultEnabled: true
      temporaryBuff: false

    - id: reinforced-potency-boons
      text: Reinforced Potency
      minor: true
      amountData:
        label: 'boons'
        default: 10
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [1%, mult]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [1%, mult]
      gw2id: 1788
      defaultEnabled: true

    - id: forceful-persistence-nonherald
      text: Forceful Persistence
      subText: non herald upkeep
      amountData:
        label: '% uptime'
        default: 43
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add] # add according to wiki
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [15%, add] # add according to wiki
      gw2id: 1803
      defaultEnabled: true

    - id: forceful-persistence-herald
      text: Forceful Persistence
      subText: per herald upkeep
      amountData:
        label: 'average stacks'
        default: 2.4
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, add] # add according to wiki
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [4%, add]
      gw2id: 1803
      defaultEnabled: true

- section: Renegade
  id: 63
  items:

    - id: ambush-commander
      text: Ambush Commander
      minor: true
      amountData:
        label: "Kalla's fervor"
        default: 5
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [2%, add]
          Outgoing Condition Damage: [2%, add]
          Outgoing Siphon Damage: [2%, add]
      gw2id: 2181
      defaultEnabled: true

    - id: blood-fury
      text: Blood Fury
      subText: 100% fury
      modifiers:
        attributes:
          Bleeding Duration: 25%
      gw2id: 2079
      defaultEnabled: true
      temporaryBuff: true

    - id: heartpiercer
      text: Heartpiercer
      modifiers:
        damage:
          Outgoing Bleeding Damage: [25%, mult]
          Outgoing Strike Damage: [15%, mult]
      wvwModifiers:
        damage:
          Outgoing Bleeding Damage: [25%, mult]
          Outgoing Strike Damage: [10%, mult]
      gw2id: 2092
      defaultEnabled: true

    - id: brutal-momentum-base
      text: Brutal Momentum
      subText: base
      minor: true
      modifiers:
        attributes:
          Critical Chance: 10%
      gw2id: 2142
      defaultEnabled: true
      temporaryBuff: false

    - id: brutal-momentum
      text: Brutal Momentum
      subText: full endurance
      minor: true
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
        advancedUptimeSimulation:
          correlation: false
      modifiers:
        attributes:
          Critical Chance: 23%
      gw2id: 2142
      defaultEnabled: true
      temporaryBuff: activeOutOfCombat

    - id: lasting-legacy
      text: Lasting Legacy
      amountData:
        label: "Kalla's fervor"
        default: 5
        quantityEntered: 1
      modifiers:
        damage:
          Outgoing Strike Damage: [3%, add]
          Outgoing Condition Damage: [1%, add]
          Outgoing Siphon Damage: [1%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [1%, add]
          Outgoing Condition Damage: [1%, add]
          Outgoing Siphon Damage: [1%, add]
      gw2id: 2100
      defaultEnabled: true

- section: Vindicator
  id: 69
  items:

    - id: leviathan-strength
      text: Leviathan Strength
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [10%, mult]
      gw2id: 2258
      defaultEnabled: true

    - id: empire-divided-above
      text: Empire Divided
      subText: above
      minor: true
      amountData:
        label: '% above 50'
        default: 100
        quantityEntered: 100
      modifiers:
        attributes:
          Power: [240, converted]
      gw2id: 2229
      defaultEnabled: true
      temporaryBuff: activeOutOfCombat

    - id: empire-divided-below
      text: Empire Divided
      subText: below
      minor: true
      amountData:
        label: '% below 50'
        default: 0
        quantityEntered: 100
      modifiers:
        attributes:
          Healing Power: [240, converted]
      gw2id: 2229
      defaultEnabled: true
      temporaryBuff: true

    - id: forerunner-of-death
      text: Forerunner of Death
      amountData:
        label: '% uptime'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [25%, add]
      wvwModifiers:
        damage:
          Outgoing Strike Damage: [15%, add]
      gw2id: 2257
      defaultEnabled: true

- section: Conduit
  id: 79
  items:

    - id: bolstered-bonds-assassin
      text: Bolstered Bonds
      subText: with Assassin equipped
      minor: true
      modifiers:
        attributes:
          Power: [75, buff]
          Ferocity: [75, buff]
      wvwModifiers:
        attributes:
          Power: [75, buff]
          Ferocity: [75, buff]
      gw2id: 2331
      defaultEnabled: false
      temporaryBuff: false

    - id: bolstered-bonds-centaur
      text: Bolstered Bonds
      subText: with Centaur equipped
      minor: true
      modifiers:
        attributes:
          Healing Power: [150, buff]
          Concentration: [150, buff]
      wvwModifiers:
        attributes:
          Healing Power: [75, buff]
          Concentration: [75, buff]
      gw2id: 2331
      defaultEnabled: false
      temporaryBuff: false

    - id: bolstered-bonds-demon
      text: Bolstered Bonds
      subText: with Demon equipped
      minor: true
      modifiers:
        attributes:
          Condition Damage: [75, buff]
          Expertise: [75, buff]
      wvwModifiers:
        attributes:
          Condition Damage: [75, buff]
          Expertise: [75, buff]
      gw2id: 2331
      defaultEnabled: false
      temporaryBuff: false

    - id: bolstered-bonds-dwarf
      text: Bolstered Bonds
      subText: with Dwarf equipped
      minor: true
      modifiers:
        attributes:
          Toughness: [150, buff]
          Vitality: [150, buff]
      wvwModifiers:
        attributes:
          Toughness: [75, buff]
          Vitality: [75, buff]
      gw2id: 2331
      defaultEnabled: false
      temporaryBuff: false

    - id: bolstered-bonds-entity
      text: Bolstered Bonds
      subText: with Entity equipped
      minor: true
      modifiers:
        attributes:
          Power: [75, buff]
          Precision: [75, buff]
          Toughness: [75, buff]
          Vitality: [75, buff]
          Concentration: [75, buff]
          Condition Damage: [75, buff]
          Expertise: [75, buff]
          Ferocity: [75, buff]
          Healing Power: [75, buff]
      wvwModifiers:
        attributes:
          Power: [50, buff]
          Precision: [50, buff]
          Toughness: [50, buff]
          Vitality: [50, buff]
          Concentration: [50, buff]
          Condition Damage: [50, buff]
          Expertise: [50, buff]
          Ferocity: [50, buff]
          Healing Power: [50, buff]
      gw2id: 2331
      defaultEnabled: false
      temporaryBuff: false

    - id: numinous-gift-yearning-empowerment
      text: Numinous Gift
      subText: with Corruption
      minor: true
      modifiers:
        attributes:
          Condition Duration: 5%
      gw2id: 2440
      defaultEnabled: false
      temporaryBuff: true

    - id: numinous-gift-determined-resolution
      text: Numinous Gift
      subText: with Retribution, 100% resolution
      minor: true
      modifiers:
        damage:
          Damage Reduction: [4.55%, mult] # changes 10% mult to 15% mult
      gw2id: 2440
      defaultEnabled: false

    - id: numinous-gift-targeted-destruction
      text: Numinous Gift
      subText: with Devastation
      minor: true
      amountData:
        label: '% vulnerability'
        default: 100
        quantityEntered: 100
      modifiers:
        damage:
          Outgoing Strike Damage: [5%, mult]
      gw2id: 2440
      defaultEnabled: false

    - id: numinous-gift-serene-rejuvenation
      text: Numinous Gift
      subText: with Salvation
      minor: true
      modifiers:
        attributes:
          Outgoing Healing: 5%
      wvwModifiers:
        attributes:
          Outgoing Healing: 3%
      gw2id: 2440
      defaultEnabled: false
      temporaryBuff: false
